module.exports = __webpack_public_path__ + "static/media/turism_plan_icon.f27377ca.svg";